import Vue from 'vue';
import TranslationHelper from '../../../../Modules/Core/Assets/js/mixins/TranslationHelper';

Vue.mixin(TranslationHelper);
